import $ from 'jquery'
import DropdownDialog from '../../controls/DropdownDialog'
import {calculateElementOffset} from '../../atBrowserUtils'

/**
 * Created by evdokimov on 05.05.2016.
 */

function WarningsController() {
    this._warningsPopup = new DropdownDialog(
        {
            wrapperClass: 'warningsPopup',
            dialogDiv: $(".warningsToShowDiv"),
            hideButtons: true,
            hideOnResize: true
        });
}

WarningsController.BOTTOM_BAR_HEIGHT = 29;

WarningsController.prototype.setInfoHoverEvents = function(noteJQEl, infos) {
    var self = this;

    noteJQEl.hover(
        function(e) {
            self.showWarningsPopup(infos, this, false);
            e.stopPropagation();
        },
        function() {
            self.hideWarningsPopup();
        })
            .mousemove(
                function(e) { self.moveWarningsPopup(e, $(".warningsPopup")); });
};

WarningsController.prototype.setWarnings = function(warningSection, warnings) {
    var warningEl = this._createWarningsElement(warnings);
    warningSection.replaceWith(warningEl);
};

WarningsController.prototype._createWarningsElement = function(warnings) {
    if (!warnings)
        return "<div class='warningsInRow'></div>";

    var warningSection = "<div class='warningsInRow'> <ul class='warning'>";

    var warning = warnings[0];
    warningSection += "<li class='firstWarning'>" + warning + "</li>";

    for (var i = 1; i < warnings.length; i++) {
        warning = warnings[i];
        warningSection += "<li>" + warning + "</li>";
    }
    warningSection += "</ul> </div>";

    return $(warningSection);
};

WarningsController.prototype.setClickEvents = function(noteJQEl, notes) {
    var self = this;
    noteJQEl.click(function(e) {
        $(".warningsToShowDiv").html($(".warningsDiv#" + $(this).attr('id')).html());
        self.showWarningsPopup(notes, this, true);
        e.stopPropagation();
    });
};

WarningsController.prototype.showWarningsPopup = function(warnings, icon, overlay) {
    var warning = warnings;

    var warningsDivContent = "<div class='firstWarning'>" + warning + "</div>";

    for (var i = 1; i < warnings.length; i++) {
        warning = warnings[i];
        warningsDivContent += "<div class='additionalWarning'>" + warning + "</div>";
    }

    $(".warningsToShowDiv").html(warningsDivContent);
    this._warningsPopup.showAt(icon, {offset: "-60px 7px", collision: "none"});
    if (!overlay)
        this._warningsPopup.removeOverlay();
};

WarningsController.prototype.hideWarningsPopup = function() {
    this._warningsPopup.hide();
};

WarningsController.prototype.moveWarningsPopup = function(event, popup) {
    popup.offset(calculateElementOffset(popup.outerHeight(), popup.outerWidth(), event, WarningsController.BOTTOM_BAR_HEIGHT));
};

export default WarningsController



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/WarningsController.js